<template>
  <v-list dense nav>
    <v-tooltip right :disabled="!value">
      <template #activator="{ on }">
        <v-list-item link dense v-on="on" @click="$emit('toggle')">
          <v-list-item-icon>
            <v-icon
              :class="{ 'mdi-rotate-180': value }"
              v-text="'mdi-chevron-left'"
            />
          </v-list-item-icon>

          <v-list-item-content
            class="caption text--secondary"
            style="opacity: 0.5;"
            v-text="'Свернуть'"
          />
        </v-list-item>
      </template>

      <div v-text="'Развернуть'" />
    </v-tooltip>
  </v-list>
</template>

<script>
export default {
  name: 'BToggleButton',
  props: {
    value: Boolean,
  },
}
</script>
